import { RouteMatch } from './router';

/**
 * Adds an `active-route` attribute to the body element, so we can use it in style hooks.
 */
export const markActiveRoute = (match: RouteMatch) => {

    document.body.setAttribute('active-route', match.route.id);
};
